// extracted by mini-css-extract-plugin
module.exports = {"blockQuote":"Blockquote_blockQuote__6OOqJ"};